module.exports = __webpack_public_path__ + "static/img/wx_head.b38ae04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/wx_head.jpg
// module id = +5/G
// module chunks = 4